/**
 * Operator-facing leaf of a tag path. Full paths like
 * `[default]311/Cell57_Axilon_Prophet/CNT_Part_Counter_ACC` are unreadably
 * long in chips; the last segment is what a technician recognizes.
 */
export function tagPathLeaf(path: string): string {
  const trimmed = path.trim()
  if (!trimmed) return path
  const slash = trimmed.lastIndexOf('/')
  if (slash >= 0 && slash < trimmed.length - 1) {
    return trimmed.slice(slash + 1)
  }
  const bracket = trimmed.lastIndexOf(']')
  if (bracket >= 0 && bracket < trimmed.length - 1) {
    return trimmed.slice(bracket + 1)
  }
  return trimmed
}
